import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M8 1.5a7 7 0 10.001 14.001A7 7 0 008 1.5zm.5 10.375a.125.125 0 01-.125.125h-.75a.125.125 0 01-.125-.125v-4.25c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125v4.25zM8 6.5A.75.75 0 018 5a.75.75 0 010 1.5z"
        fill="#FF4D4F"
      />
    </Svg>
  );
}

export default SvgComponent;
